import type {
  TNavigationOption,
  TNavigationOptionNest,
  TNavigationOptions,
  TUINavigationOptions,
} from './types';

// flattens the tree structure
// ids are separated by slashes
// initially visible path is at '/'
export const flattenNavigationOptions = (
  options: TNavigationOptions,
  path: string = '/',
): TUINavigationOptions =>
  options.reduce<TUINavigationOptions>((flat, option) => {
    if (!flat[path]) flat[path] = [];
    if (isNavigationOptionWithChildren(option)) {
      const childPath = (path.endsWith('/') ? path : `${path}/`) + option.id;
      flat = {
        ...flat,
        ...flattenNavigationOptions(option.children, childPath),
      };
    }
    flat[path].push(option);
    return flat;
  }, {} as TUINavigationOptions);

export const isNavigationOptionWithChildren = (
  option: TNavigationOption,
): option is TNavigationOptionNest => (option as TNavigationOptionNest).children !== undefined;
